import type { OfflineLedger, OfflineLedgerEntry } from './offline-queue'

/** Stable React snapshots observe every ledger field, not a partial string signature. */
export function createLedgerView(ledger: OfflineLedger) {
  let snapshot: OfflineLedgerEntry[] | undefined
  let unsubscribe: (() => void) | undefined
  const listeners = new Set<() => void>()
  return {
    read: () => (snapshot ??= ledger.list()),
    subscribe(listener: () => void) {
      listeners.add(listener)
      if (!unsubscribe) {
        // React rechecks after subscribing, closing the read/subscribe gap.
        snapshot = ledger.list()
        unsubscribe = ledger.subscribe(() => {
          snapshot = ledger.list()
          for (const notify of listeners) {
            try {
              notify()
            } catch {
              /* Other subscribers still receive the revision. */
            }
          }
        })
      }
      return () => {
        listeners.delete(listener)
        if (!listeners.size) {
          unsubscribe?.()
          unsubscribe = undefined
          snapshot = undefined
        }
      }
    },
  }
}
